import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-square-arrow-reload-01',
  standalone: true,
  templateUrl: '../../assets/square-arrow-reload-01.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamSquareArrowReload01Icon {}
